module.exports = __webpack_public_path__ + "img/motorcycle.33b613bc.png";